// Dependencies
require("webstrap/scaffolding");

// Styles
require("./social-1-1.scss");

// JavaScript
var $ = require("jquery"),
    $fbHolder = $(".social-1-1__facebook-holder"),
    $fbPage = $(".fb-page");

if ($fbHolder.length > 0 && $fbPage.length > 0) {
    var timeout = null;
    
    var fnResize = function () {
        // Hide FB Frame (solve problem when retreiving width / height)
        $fbPage.hide();
        // Get dimension
        var fbWidth = $fbHolder.width();
        var fbHeight = $fbHolder.height();
        // Restore visibility
        $fbPage.show();
        // Apply new dimension
        if (!isNaN(fbWidth) && !isNaN(fbHeight)) {
            $(".fb-page").attr("data-width", fbWidth);
            $(".fb-page").attr("data-height", fbHeight);
            if (window.FB) {
                window.FB.XFBML.parse();
            }
        }
    };

    var fnDebounceResize = function () {
        clearTimeout(timeout);
        timeout = setTimeout(fnResize, 300);
    };

    $(window).on("resize.social", fnDebounceResize);

    fnResize();
}



//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/catalog/social-1/view-1/index.js
// module id = 230
// module chunks = 0